module.exports = __webpack_public_path__ + "img/full3-min.fabf0956.png";